import Api from "../../../../util/Api";

export default function getInitState() {
    return {
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            initOnRender: false,
            global_search: {
                visibility: false,
            }
        },

        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Keresés',
                event_name: "customClick",
                class: "btn btn btn-danger my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Exportálás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'export'
            }
        ],

        searchFields: [
            {
                name: "occupationHealthPartnerId",
                label: "FEÜ partner",
                formSize: 3,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllPartnersToSelect,
                    formatText: function (val) {
                        return val.name;
                    },
                    formatOption: function (val) {
                        return val.name;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'name',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "vaccinationId",
                label: "Védőoltás",
                formSize: 3,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.listOccupationHealthVaccinationByName,
                    formatText: function(val){
                        return val.name;
                    },
                    formatOption: function(val){
                        return val.name;
                    },
                    minimumInputLength: 0,
                    returnValue: 'id',
                    searchOnServer: false,
                    filteredAttr: 'name',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "dateOfVaccinationFrom",
                label: "Oltás dátumától",
                formSize: 3,
                formType: "date"
            },
            {
                name: "dateOfVaccinationTo",
                label: "Oltás dátumáig",
                formSize: 3,
                formType: "date"
            },
            {
                name: "nextDateOfVaccinationFrom",
                label: "Következő oltás dátumától",
                formSize: 3,
                formType: "date"
            },
            {
                name: "nextDateOfVaccinationTo",
                label: "Következő oltás dátumáig",
                formSize: 3,
                formType: "date"
            },
        ],

        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false
            },
            {
                name: "occupationHealthPartner",
                label: "FEÜ Partner",
                visibility: true,
                sort: true
            },
            {
                name: "occupationHealthPartnerSite",
                label: "FEÜ Partner telephely",
                visibility: true,
                sort: true
            },
            {
                name: "occupationHealthSiteGroup",
                label: "Munkakör",
                visibility: true,
                sort: true
            },
            {
                name: "patient.name",
                label: "Páciens",
                visibility: true
            },
            {
                name: "vaccinationName",
                label: "Védőoltás",
                visibility: true,
                sort: true
            },
            {
                name: "dateOfVaccination",
                label: "Oltás dátuma",
                visibility: true,
                sort: true,
                slot_name: "date_format"
            },
            {
                name: "expirationMonth",
                label: "Oltás lejárati ideje (hónap)",
                visibility: true
            },
            {
                name: "nextDateOfVaccination",
                label: "Következő oltás dátuma",
                visibility: true,
                sort: true,
                slot_name: "productionTime_format"
            }
        ]
    }
}
